import Checkbox from "../../../../../components/common/Checkbox/Checkbox"
import DatatableComponent from "../../../../../components/common/DatatableComponent/DatatableComponent"
import styles from "./DeliveryOption.module.scss"

const DeliveryOption = () => {

  const deliveryTypeData = [
    { type: 'Economy' },
    { type: 'Standard' },
    { type: 'Express' },
  ]

  const deliveryTypeColumns = [
    { name: 'Type', selector: row => row.type },
    { name: 'Available', cell: () => <Checkbox />, center: true },
    { name: 'Preferred', cell: () => <Checkbox />, center: true }
  ]

  const shippingCarrierData = [
    { type: 'DHL' },
    { type: 'FedEx' },
    { type: 'UPS' },
    { type: 'TCS' },
    { type: 'Leopards Courier' },
    { type: 'BlueEx' },
    { type: 'Pakistan Post' },
    { type: 'M & P Courier' },
    { type: 'PCL' },
    { type: 'Trax' },
  ]

  const shippingCarrierColumns = [
    { name: 'Type', selector: row => row.type },
    { name: 'Economy', cell: () => <Checkbox />, center: true },
    { name: 'Standard', cell: () => <Checkbox />, center: true },
    { name: 'Express', cell: () => <Checkbox />, center: true },
    { name: 'Preferred', cell: () => <Checkbox />, center: true },
  ]

  return (
    <div className="py-3">
      <div className={styles["heading"]}>Delivery Type</div>
      <div className="p-2 bg-white">
        <div className={styles["wrapper"]}>

          <DatatableComponent data={deliveryTypeData} columns={deliveryTypeColumns} type={'gray'} />

        </div>
      </div>

      <div className={styles["heading"]}>Shipping Carrier</div>
      <div className="p-2 bg-white">
        <div className={styles["wrapper"]}>

          <DatatableComponent data={shippingCarrierData} columns={shippingCarrierColumns} type={'gray'} />

        </div>
      </div>
    </div>
  )
}

export default DeliveryOption
